import { ApiMethod } from '@wajeez-web/stores/base';
import {
  Server,
  identityClient,
  publicIdentityClient,
} from '@wajeez-web/core/api-base';
import {
  thunkErrorHandler,
  thunkResponseCheckerSdk,
} from '@wajeez-web/core/utils';

import { GetFeedbackOptionsInput } from './types';

export const getFeedbackOptions: ApiMethod<
  GetFeedbackOptionsInput,
  Server.FeedbackOptionOutput[],
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_Feedback_Client(
          undefined,
          publicIdentityClient
        );

        return client.feedback_getFeedbackOptions_get_V1('1', data.type);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};

export const submitFeedback: ApiMethod<
  Server.SubmitFeedbackInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_Feedback_Client(
          undefined,
          identityClient
        );

        return client.feedback_submitFeedback_post_V1(data);
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};
